import React from "react";
import { useNavigate } from "react-router-dom";
import { ExternalLink, Search, CheckCircle2, XCircle } from "lucide-react";
import { SevBadge, fmtD, fmtDT, bookingLink } from "./shared";

function Actions({ a, onStatus }) {
  const btn = "inline-flex items-center gap-1 rounded-lg px-2.5 py-1 text-xs border transition-colors";
  return (
    <div className="flex flex-wrap gap-1.5 md:justify-end">
      {a.status === "open" && <button type="button" onClick={() => onStatus(a, "in_review")} data-testid={`anomaly-review-${a.id}`} className={`${btn} border-sky-500/40 text-sky-200 hover:bg-sky-500/10`}><Search size={12} />In verifica</button>}
      <button type="button" onClick={() => onStatus(a, "resolved")} data-testid={`anomaly-resolve-${a.id}`} className={`${btn} border-emerald-500/40 text-emerald-200 hover:bg-emerald-500/10`}><CheckCircle2 size={12} />Risolta</button>
      <button type="button" onClick={() => onStatus(a, "not_relevant")} data-testid={`anomaly-dismiss-${a.id}`} className={`${btn} border-slate-700 text-slate-400 hover:text-slate-200`}><XCircle size={12} />Non pertinente</button>
    </div>
  );
}

function AnomalyRow({ a, labels, statuses, onStatus, readOnly }) {
  const nav = useNavigate();
  return (
    <div className="rounded-xl border border-slate-800 bg-[#0C0B09] p-3.5 grid gap-3 md:grid-cols-[1.6fr_1fr_330px] md:items-center" data-testid={`anomaly-${a.id}`}>
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <SevBadge sev={a.severity} testid={`anomaly-sev-${a.id}`} />
          <span className="text-white font-semibold text-sm">{labels[a.type] || a.type}</span>
          {a.travel_no && <span className="font-mono-num text-amber-300 text-xs">{a.travel_kind === "train" ? "Treno" : a.travel_kind === "flight" ? "Volo" : ""} {a.travel_no}</span>}
          <span className="text-[10px] uppercase tracking-widest text-slate-500" data-testid={`anomaly-status-${a.id}`}>{statuses[a.status]}</span>
        </div>
        <div className="text-sm text-slate-300 mt-1">{a.reason}</div>
        <div className="text-xs text-amber-200/80 mt-0.5">Azione consigliata: {a.action}</div>
      </div>
      <div className="text-xs text-slate-400 space-y-0.5">
        <button type="button" onClick={() => nav(bookingLink(a.booking_id))} data-testid={`anomaly-open-${a.id}`} className="inline-flex items-center gap-1 text-amber-300 hover:text-amber-200 font-mono-num font-bold">
          <ExternalLink size={12} />#{a.booking_number || a.booking_id.slice(0, 8)}
        </button>
        <div>{fmtD(a.booking_date)} {a.booking_time || ""} · {a.service_type || "Servizio"}</div>
        <div className="text-slate-500">{a.source} · rilevata {fmtDT(a.first_seen)} · agg. {fmtDT(a.last_seen)}</div>
      </div>
      {!readOnly && <Actions a={a} onStatus={onStatus} />}
    </div>
  );
}

export function AnomalyList({ items, labels, statuses, onStatus, readOnly, empty }) {
  if (!items.length) return <div className="text-sm text-slate-500 text-center py-8" data-testid="anomaly-empty">{empty}</div>;
  return <div className="space-y-2">{items.map((a) => <AnomalyRow key={a.id} a={a} labels={labels} statuses={statuses} onStatus={onStatus} readOnly={readOnly} />)}</div>;
}
